<div class="rt-card" [class.reply]="noteIsReply">
  @if (note.visibility?.level !== VisibilityLevel.Public && !note.replyToId) {
    <div class="visibility">
      <rt-visibility-selector-container
        [visibility]="note.visibility!"
        [editable]="false"
      ></rt-visibility-selector-container>
      @if (!withNewStyling) {
        <rt-divider></rt-divider>
      }
    </div>
  }

  <div
    class="note"
    [class.reply]="noteIsReply"
    [class.editing]="editing"
    (mouseenter)="setHeaderButtonsVisibility(true)"
    (mouseleave)="setHeaderButtonsVisibility(false)"
  >
    @if (!editing) {
      <div class="precontent">
        @if (noteIsReply && withNewStyling) {
          <div class="indicator"></div>
        }
        <div class="avatar-wrapper" [class.smaller]="noteIsReply">
          <rt-note-avatar
            [author]="state.author"
            [triggered]="note.triggered ?? null"
            [size]="withNewStyling ? (noteIsReply ? 'small-x' : 'small') : 'base'"
          ></rt-note-avatar>
        </div>
        @if ((note.replies?.length || hasConnector) && withNewStyling) {
          <div class="rectangle" [class.connector]="hasConnector"></div>
        }
      </div>
      <div class="content" [class.new]="withNewStyling">
        <div class="entry">
          <div
            class="header"
            layout
            layout-space-between
            layout-align-items-center
            padding-bottom-x
          >
            <div class="author-container">
              <div class="author">
                <span>{{
                  !note.triggered ? state.authorName : ('app.notes.automated_action' | translate)
                }}</span>
                @if (!withNewStyling && note.guest) {
                  <rt-badge
                    color="optional"
                    [text]="'app.common.guest' | translate"
                    margin-left-small-x
                  >
                  </rt-badge>
                }
              </div>
              @if (withNewStyling && note.guest) {
                <rt-badge
                  color="optional"
                  [text]="'app.common.guest' | translate"
                  margin-left-small-x
                >
                </rt-badge>
              }
            </div>
            <div layout>
              @if (!withNewStyling && showHeaderButtons && !isReadOnly) {
                <rt-group class="header-buttons">
                  <ng-container *ngTemplateOutlet="actionButtons" />
                </rt-group>
              }
              @if (withNewStyling) {
                <rt-group
                  [class.visible]="showHeaderButtons && !isReadOnly"
                  class="header-buttons"
                  variant="stacked"
                  padding-left-small-xx
                >
                  <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
                </rt-group>
              }
              @if (note.pinnedAt) {
                <rt-icon-button
                  [rtTooltip]="'app.notes.unpin' | translate"
                  (click)="unpinNote()"
                  [attr.margin-left-small-xx]="withNewStyling ? null : ''"
                  variant="plain"
                  iconName="pin"
                  shape="square"
                  size="small"
                >
                </rt-icon-button>
              }

              <rt-date
                [time]="note.createdAt!"
                [tiny]="true"
                class="created-at"
                margin-left-small-xx
              ></rt-date>
            </div>
          </div>

          <div
            #noteRenderer="prosemirrorRender"
            prosemirrorDefaultConfig
            [prosemirrorRender]="note.bodyJson"
            [prosemirrorRenderConfig]="ProsemirrorConfig"
            (prosemirrorEvents)="onWysiwygEvent($event)"
          ></div>
        </div>

        <rt-group class="attachments" variant="horizontal">
          @for (attachment of note.attachments; track trackById($index, attachment)) {
            <rt-attachment-item [attachment]="attachment" type="compact-card"> </rt-attachment-item>
          }
        </rt-group>

        @if (!isReadOnly) {
          <div class="meta" [attr.margin-top-small-xx]="withNewStyling ? '' : null">
            <div layout-vertical layout-align-items-start>
              @if (currentAdmin) {
                <rt-note-reactions-container
                  [noteId]="note.id!"
                  [currentAdminId]="currentAdmin.id"
                  [reactions]="note.reactions!"
                  [projectedContentTpl]="replyButton"
                ></rt-note-reactions-container>
              }
              <ng-template #replyButton>
                <rt-button
                  [disabled]="notesDeleteLoading.includes(note.id!)"
                  variant="plain"
                  (click)="showReply()"
                  class="reply"
                  size="small"
                >
                  {{ 'app.notes.reply' | translate }}
                </rt-button>
              </ng-template>
            </div>
          </div>
        }
      </div>
    }

    @if (editing) {
      <div class="edit-form">
        <rt-note-form
          [active]="true"
          [note]="$any(note)"
          [candidateId]="note.candidateId!"
          [attachmentsTemp]="attachmentsTemp ? attachmentsTemp[note.id!] : []"
          [noteSaveLoading]="noteSaveLoading.includes(note.id!)"
          [attachmentLoading]="
            !!(noteAttachmentLoading[note.id!] && noteAttachmentLoading[note.id!].length)
          "
          [canDeleteAttachments]="canDeleteAttachments"
          [admins]="adminsList"
          [disallowedUsers]="disallowedAdminsList"
          [withNewStyling]="withNewStyling"
          (cancelClick)="cancel()"
          (changeNoteVisibility)="changeNoteVisibilityClass($event)"
          (noteSaveClick)="noteSaveClick.emit($any($event))"
          (uploadAttachmentClick)="uploadAttachmentClick.emit($any($event))"
          (deleteAttachmentClick)="deleteAttachmentClick.emit($event)"
        >
        </rt-note-form>
      </div>
    }
  </div>

  @if (!withNewStyling && ((note.replies && note.replies.length > 0) || replying)) {
    <rt-divider class="reply-divider"></rt-divider>
  }

  @if (replying && state.replyNote) {
    <div class="reply-form note">
      <rt-note-form
        [active]="true"
        [replyToId]="$any(note.id)"
        [candidateId]="note.candidateId!"
        [canDeleteAttachments]="canDeleteAttachments"
        [offerId]="note.offerId ?? note.talentPoolId!"
        [note]="$any(state.replyNote)"
        [allNotesFlat]="allNotesFlat"
        [autofocus]="true"
        [noteSaveLoading]="noteSaveLoading.includes(state.replyTempId)"
        [attachmentLoading]="
          !!(
            noteAttachmentLoading[state.replyTempId] &&
            noteAttachmentLoading[state.replyTempId].length
          )
        "
        [attachmentsTemp]="attachmentsTemp ? attachmentsTemp[state.replyTempId] : []"
        [admins]="adminsList"
        [disallowedUsers]="disallowedAdminsList"
        [withNewStyling]="withNewStyling"
        (changeNoteVisibility)="changeNoteVisibilityClass($event)"
        (typingStart)="replyTypingStart.emit({ replyToId: $any(state.replyTempId) })"
        (typingFinish)="replyTypingFinish.emit()"
        (cancelClick)="cancel()"
        (noteSaveClick)="noteSaveClick.emit($any($event))"
        (uploadAttachmentClick)="uploadAttachmentClick.emit($any($event))"
        (replyChanges)="replyChanges.emit($any($event))"
        (deleteAttachmentClick)="deleteAttachmentClick.emit($event)"
      >
      </rt-note-form>
    </div>
  }

  @if (typingAdmins.length > 0) {
    <rt-divider></rt-divider>
    <div class="typing-indicator">
      <rt-note-typing-indicator-message [typingAdmins]="typingAdmins">
      </rt-note-typing-indicator-message>
    </div>
  }

  @if (note.replies && note.replies.length > 0 && replying) {
    <rt-divider></rt-divider>
  }

  @if (note.replies && note.replies.length > 0) {
    <div class="replies">
      @if (!withNewStyling) {
        <rt-divider variant="line light"></rt-divider>
      }
      @for (
        reply of note.replies;
        track trackByNote(index, reply);
        let index = $index;
        let first = $first;
        let last = $last
      ) {
        @if (allRepliesVisible || note.replies.length < 6 || first || last) {
          <div class="reply">
            <rt-note-item
              [note]="reply"
              [noteIsReply]="true"
              [editing]="notesBeingEdited.includes(reply.id!)"
              [replying]="notesBeingRepliedTo.includes(reply.id!)"
              [cachedReply]="cachedReply"
              [attachmentsTemp]="attachmentsTemp"
              [canDeleteAttachments]="canDeleteAttachments"
              [canHighLevelDataAccess]="canHighLevelDataAccess"
              [currentAdmin]="currentAdmin"
              [currentlyTypedNotes]="currentlyTypedNotes"
              [isVisibilityEnabled]="isVisibilityEnabled"
              [notesBeingRepliedTo]="notesBeingRepliedTo"
              [notesBeingEdited]="notesBeingEdited"
              [noteSaveLoading]="noteSaveLoading"
              [notesDeleteLoading]="notesDeleteLoading"
              [noteAttachmentLoading]="noteAttachmentLoading"
              [allNotesFlat]="allNotesFlat"
              [adminsList]="adminsList"
              [disallowedAdminsList]="disallowedAdminsList"
              [isReadOnly]="isReadOnly"
              [withNewStyling]="withNewStyling"
              [hasConnector]="!last"
              (replyTypingStart)="replyTypingStart.emit($event)"
              (replyTypingFinish)="replyTypingFinish.emit()"
              (noteReplyClick)="noteReplyClick.emit($event)"
              (noteEditClick)="noteEditClick.emit($event)"
              (noteDiscardClick)="noteDiscardClick.emit($event)"
              (noteSaveClick)="noteSaveClick.emit($event)"
              (noteDeleteClick)="noteDeleteClick.emit($event)"
              (uploadAttachmentClick)="uploadAttachmentClick.emit($event)"
              (replyChanges)="replyChanges.emit($event)"
              (deleteAttachmentClick)="deleteAttachmentClick.emit($event)"
              (noteChecklistClick)="noteChecklistClick.emit($event)"
            >
            </rt-note-item>
            @if (!withNewStyling && ((note.replies && note.replies.length > 1) || replying)) {
              <rt-divider></rt-divider>
            }
          </div>
        }
        @if (!allRepliesVisible && note.replies.length > 5 && index === 1) {
          <rt-thread-expander
            [text]="'app.notes.show_more_replies' | translate: { count: note.replies.length - 2 }"
            (expand)="showAllReplies()"
            class="thread-expander"
          ></rt-thread-expander>
          <rt-divider></rt-divider>
        }
      }
    </div>
  }
</div>
<ng-template #actionButtons>
  @if (isEditable() && !note.pinnedAt) {
    <rt-icon-button
      [disabled]="notesDeleteLoading.includes(note.id!)"
      (click)="showEdit()"
      [attr.margin-right-small-xx]="withNewStyling ? null : ''"
      variant="plain"
      iconName="edit"
      shape="square"
      size="small"
    >
    </rt-icon-button>
  }
  <rt-icon-button
    #moreDropdownTrigger="rtOverlayOrigin"
    [rtTooltip]="'app.common.more' | translate"
    [pressed]="moreDropdown.open"
    (click)="toggleDropdown(moreDropdown)"
    rt-overlay-origin
    variant="plain"
    iconName="more-vert"
    shape="square"
    size="small"
  >
  </rt-icon-button>
  <ng-template
    #moreDropdown="rtConnectedOverlay"
    [origin]="moreDropdownTrigger"
    (backdropClick)="toggleDropdown(moreDropdown)"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown [width]="DropdownWidth.SmallX">
      @if (!noteIsReply && !note.pinnedAt) {
        <rt-dropdown-item (click)="pinNote(); toggleDropdown(moreDropdown)">
          <rt-icon prefix name="pin"></rt-icon>
          {{ 'app.notes.pin_note' | translate }}
        </rt-dropdown-item>
      }
      @if (isEditable() && note.pinnedAt) {
        <rt-dropdown-item (click)="showEdit(); toggleDropdown(moreDropdown)">
          <rt-icon prefix name="edit"></rt-icon>
          {{ 'app.common.edit' | translate }}
        </rt-dropdown-item>
      }
      @if (isDeletable()) {
        <rt-dropdown-item (click)="deleteNote(); toggleDropdown(moreDropdown)">
          <rt-icon prefix name="delete"></rt-icon>
          {{ 'app.common.delete' | translate }}
        </rt-dropdown-item>
      }
    </rt-dropdown>
  </ng-template>
</ng-template>
